<div
  class="title bold"
>{{title}}</div>

<div *ngIf="subtitle?.length > 0" class="subtitle">{{subtitle}}</div>
